<template>
  <div class="addRejectReason">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="reason"
        maxlength="500"
        show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCompanyRejectReason,
  proxyAuditApply,
  auditCooperationApply,
} from "@/api/organization";
export default {
  data() {
    return {
      id: "",
      type: "",
      licenseNum: "",
      dialogTitle: "",
      dialogVisible: false,
      reason: "",
    };
  },
  methods: {
    // 初始化
    init(type, id, licenseNum) {
      this.id = id;
      this.licenseNum = licenseNum;
      this.type = type;
      this.dialogTitle = type === "1" ? "填写拒绝合作原因" : "填写审核驳回原因";
      this.dialogVisible = true;
    },
    addCompanyRejectReason(type, licenseNum, reason) {
      addCompanyRejectReason({ type, licenseNum, reason }).then((res) => {
        if (res.code === 0) {
          this.$emit("refresh");
          this.$message({
            type: "success",
            message: "拒绝成功",
          });
          this.handleClose()
        }
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
      this.reason = ''
    },
    // 确认
    handleAffirm() {
      if (this.reason === "") {
        this.$message({
          message: "请填写原因",
          type: "warning",
        });
        return;
      }

      if (this.type === "1") {
        proxyAuditApply({ auditStatus: "2", id: this.id }).then((res) => {
          if (res.code === 0) {
            this.addCompanyRejectReason(
              this.type,
              this.licenseNum,
              this.reason
            );
          }
        });
      } else if (this.type === "2") {
        auditCooperationApply({ auditStatus: "2", id: this.id }).then((res) => {
          if (res.code === 0) {
            this.addCompanyRejectReason(
              this.type,
              this.licenseNum,
              this.reason
            );
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addRejectReason {
  ::v-deep .el-dialog__body {
    padding: 10px 20px !important;
  }
}
</style>